import { GlobalContext } from "context/GlobalContext";
import { useContext } from "react";
import { BackArrow } from "themes/Icon";
import { isPermit } from "utils/permissionCheck";
import style from "../../details.module.scss";
import ApprovalBtn from "./actionButtons/approvalBtn";
import NonApprovalButtons from "./actionButtons/nonApprovalBtn";

function Header(props) {
  const {
    handleClose,
    selectedArticle,
    setIsApprove,
    setIsReject,
    Approval,
    onEdit,
    setDlt,
    tabActive,
  } = props;

  const { state } = useContext(GlobalContext);

  console.log(
    selectedArticle?.project_status_flg,
    "selectedArticle?.project_status_flg"
  );

  return (
    <>
      <div
        className={`flex gap-2 align-center w-full ${style["title-container"]}`}
      >
        <span onClick={handleClose} className={`${style["back-icon"]}`}>
          <BackArrow />
        </span>

        <div
          className={`flex wrap align-center gap-4 w-full ${style["title-chip-wrapper"]}`}
        >
          <h2 className="page-title-details">{selectedArticle?.title}</h2>
        </div>
      </div>
      <div className={`flex align-center gap-4 ${style["button-wrapper"]}`}>
        {Approval &&
        selectedArticle?.project_status_flg === 1 &&
        isPermit(8, "approve_reject") ? (
          <ApprovalBtn
            onEdit={onEdit}
            setReject={setIsReject}
            setApprove={() => setIsApprove(true)}
            selectedArticle={selectedArticle}
          />
        ) : (
          <>
            {isPermit(8, "delete") && (
              <NonApprovalButtons
                onEdit={onEdit}
                setDlt={setDlt}
                selectedArticle={selectedArticle}
                tabActive={tabActive}
              />
            )}
          </>
        )}
      </div>
    </>
  );
}

export default Header;
